import { Component, OnInit, OnDestroy, ViewChild, HostListener, Input, AfterViewInit, ViewChildren, Output, EventEmitter, Host } from '@angular/core';
import * as Chart from 'chart.js';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { getQueryParamFromAncestorRoute, getParamFromAncestorRoute } from '../../../utilities/route.utilities';
import { BillingService } from '../../../services/billing.service';
import { ConsumptionService } from '../../../services/consumption.service';
import { TotalConsumptionGridItem } from '../grid-item/total-consumption-grid-item.component';

@Component({
    selector: 'total-consumption-chart',
    template: '<canvas style="height:35rem;" id="basechart" #basechart></canvas>',
    styles: [':host { position: relative; display:block; }']
})
export class TotalConsumptionChartComponent implements AfterViewInit, OnDestroy {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    ctx: any;
    public subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    chartData: any;
    supplyTypesData: any[] = [];
    filterList: any[] = [];
    filter: any[] = [];
    heatGradientStroke: any;
    hotWaterGradientStroke: any;
    coldWaterGradientStroke: any;
    supplyType: string;
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    timePeriod: number = 12;
    siteId: number = 0;
    averageConsumption: any;
    initalLoad: boolean = false;

    hasCurrent: boolean = false;
    has_180365Days: boolean = false;
    has_365Days: boolean = false;
    has_6090Days: boolean = false;
    has_90180Days: boolean = false;
    hasBankTransfer: boolean = false;

    constructor(
        private consumptionService: ConsumptionService,
        private route: ActivatedRoute,
        private router: Router,
        @Host() private parent: TotalConsumptionGridItem
    ) { }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {

        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId') ? getQueryParamFromAncestorRoute(this.route, 'siteId') : 0;
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod') == null ? 12 : getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.supplyType = getQueryParamFromAncestorRoute(this.route, 'supplyCategory') == null ? "Heat" : getQueryParamFromAncestorRoute(this.route, 'supplyCategory');

        this.search();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    unique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    firstLetterToLower(item: string) {
        return item.charAt(0).toLowerCase() + item.slice(1);
    }


    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    search() {

        this.chartData = [];
        if (this.timePeriod == 12) {
            //monthly
            this.consumptionService.getMonthlyTotalConsumption(this.clientId, this.supplyType, this.siteId).then((result) => {
                this.averageConsumption = result;
                this.chartData = this.processData(this.averageConsumption);
                this.parent.hasData = true;
                this.parent.hasLoading = false;
                this.createChart();
            }).catch(reason => {
                this.parent.hasData = false;
                this.parent.hasLoading = false;
            });
        }

        if (this.timePeriod == 90) {
            // daily
            this.consumptionService.getDailyTotalConsumption(this.clientId, this.supplyType, this.siteId).then((result) => {
                this.averageConsumption = result;
                this.chartData = this.processData(this.averageConsumption);
                this.parent.hasData = true;
                this.parent.hasLoading = false;
                this.createChart();
            }).catch(reason => {
                this.parent.hasData = false;
                this.parent.hasLoading = false;
            });
        }
    }

    processData(data: any[]) {

        if (!data || data.length == 0) return;
        let monthCount: number = 0;
        this.hasCurrent = false;
        this.has_180365Days = false;
        this.has_365Days = false;
        this.has_6090Days = false;
        this.has_90180Days = false;

        let graphData = {
            labels: [],
            thisYearTotalCons: [],
            lastYearTotalCons: [],
            unit: ''
        };


        graphData.thisYearTotalCons = data.map(item => {
            if (this.timePeriod == 12) { item.monthYearDate = item.monthYearDate.split('T')[0]; } else { item.date = item.date.split('T')[0];}
            return {
                x: this.timePeriod == 12 ? item.monthYear : item.date,
                y: item.consumption,
                label: item.unit
            }
        });

        graphData.lastYearTotalCons = data.filter(x => x.highBoundary !== null).map(item => {
            if (this.timePeriod == 12) { item.monthYearDate = item.monthYearDate.split('T')[0]; } else { item.date = item.date.split('T')[0]; }
            return {
                x: this.timePeriod == 12 ? item.monthYearDate : item.date,
                y: item.consumptionLy,
                label: item.unit
            }
        });

        graphData.unit = data[0].unit;

        return (graphData);
    }

    private getChartConfig(): any {
        let config = {
            type: 'line',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3',
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var allData: any = data != null && data.datasets != null && tooltipItem != null && tooltipItem.datasetIndex != null ? data.datasets[tooltipItem.datasetIndex].data : [];
                            var hoverData: any = data != null && data.datasets != null && tooltipItem != null && tooltipItem.datasetIndex != null ? data.datasets[tooltipItem.datasetIndex] : [];
                            var tooltipLabel: any = data != null && data.labels != null && tooltipItem != null && tooltipItem.index != null ? data.labels[tooltipItem.index] : [];
                            var tooltipData: any = allData != null && allData.length > 0 && tooltipItem != null && tooltipItem.index != null ? allData[tooltipItem.index] : [];

                            return hoverData.label + ' ' + parseFloat(tooltipData.y).toFixed(3) + ' (' + tooltipData.label + ')';

                        }
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        barThickness: 20,
                        scaleLabel: {
                            display: true,
                            labelString: 'Month',
                            fontSize: 15,
                            fontStyle: "bold",
                        },
                        type: 'time',
                        displayFormats: {
                            'month': 'MM',
                        },
                        gridLines: {
                            display: false
                        },
                        time: {
                            unit: 'month',
                            unitStepSize: 1,
                            displayFormats: {
                                'month': 'MMM'
                            }
                        },
                    }],
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            },
                            id: "y-axis-0",
                            position: 'left',
                            scaleLabel: {
                                display: true,
                                labelString: 'Consumption ' + '(' + this.chartData.unit + ')',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                            gridLines: {
                                display: true
                            }
                        },
                    ]

                }
            }
        }

        return config;
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        if (this.chartData.thisYearTotalCons && this.chartData.thisYearTotalCons.length > 0) {
            datasets.push({
                type: 'line',
                label: 'This year',
                yAxisID: 'y-axis-0',
                data: this.chartData.thisYearTotalCons,
                backgroundColor: '#00539f',
                borderColor: '#00539f',
                pointBorderColor: '#00539f',
                pointBackgroundColor: '#00539f',
                pointHoverBackgroundColor: '#00539f',
                fill: false
            });
        }


        if (this.chartData.lastYearTotalCons && this.chartData.lastYearTotalCons.length > 0) {
            datasets.push({
                type: 'line',
                label: 'Last year',
                yAxisID: 'y-axis-0',
                data: this.chartData.lastYearTotalCons,
                backgroundColor: '#9eb3be',
                borderColor: '#9eb3be',
                pointBorderColor: '#9eb3be',
                pointBackgroundColor: '#9eb3be',
                pointHoverBackgroundColor: '#9eb3be',
                fill: false
            });
        }

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets
            }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }

}
